import * as firebase from "firebase";

export default (to, from, next) => {
    if (firebase.auth().currentUser) {
        console.log("user is logged in an continued to route ", to.path);
        next();
    } else {
        console.log("user is not logged in and was redirected to /login");
        next("/login")
    }
}